import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Image } from 'primereact/image';
import DummyImage from "../../../assets/imgs/dummy-img.png"
import "../shared.css"
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import { handlePostRequest } from "../../../services/PostTemplate";
import { toast } from "react-toastify";
import { baseURL } from "../../../Config";
import { handlePutRequest } from "../../../services/PutTemplate";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const genderLov = [
    { name: "Male", value: "male" },
    { name: "Female", value: "female" }
]

const PassengerProfile = () => {
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const [image, setImage] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);

    const userId = useSelector((state) => state.authenticationSlice?.userId)
    const loginData = useSelector((state) => state.authenticationSlice?.loginData);
    const dispatch = useDispatch();
    const history = useHistory();


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                setImage(fileReader.result);
            };
            fileReader.readAsDataURL(file);
            setUploadedFile(file);
        }   // const handleImageChange = async (event) => {
        //     const file = event.target.files[0];

        //     if (!file) return;
        //     const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
        //     if (!validImageTypes.includes(file.type)) {
        //         toast.error({
        //             message: "Invalid File Type",
        //             description: "Please upload a valid image (JPG, JPEG, or PNG).",
        //         });
        //         return;
        //     }


        //     const fileReader = new FileReader();
        //     fileReader.onload = () => {
        //         setImage(fileReader.result);
        //     };
        //     fileReader.readAsDataURL(file);
        //     setUploadedFile(file);


        // };
    };


    const parseDate = (dateString) => {
        return dateString ? moment(dateString, 'DD-MM-YYYY').toDate() : null;
    };

    const validationSchema = Yup.object().shape({
        firstName: Yup.mixed().required("This field is required."),
        lastName: Yup.mixed().required("This field is required."),
        dob: Yup.mixed().required("This field is required."),
        gender: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            firstName: "",
            lastName: "",
            corporateCode: "",
            gender: "",
            dob: null,
            mobile: "",
            file: ""
        },

        onSubmit: async (data) => {
            if (uploadedFile) {
                const uploadPayload = {
                    userId: userId,
                    file: image,
                };
                try {
                    const response = await dispatch(
                        handlePostRequest("api/user/profileimage", uploadPayload, true, true)
                    );

                    if (response?.success) {
                    }
                } catch (error) {
                }
            }

            if (data.mobile !== loginData?.data?.mobile) {
                const mobilePayload = {
                    userId,
                    mobile: data.mobile,
                };
                try {
                    const response = await dispatch(
                        handlePostRequest("api/user/lookup", mobilePayload, true, true)
                    );
                    if (response?.status) {
                        history.push({
                            pathname: '/otppp',
                            state: { userId, mobile: data.mobile }
                        })
                    }
                    return response;
                } catch (error) {
                    console.error("Error updating mobile:", error);
                }
            }
            const parseDate = moment(data.dob).format('DD-MM-YYYY');
            let profilePayload = {
                userId: userId,
                firstName: data.firstName,
                lastName: data.lastName,
                corporateCode: data.corporateCode,
                // activeCorporateCode: data.activeCorporateCode,
                gender: data.gender,
                dob: parseDate,
            }

            setSaveBtnLoading(true);

            try {
                const response = await dispatch(handlePostRequest("api/user/updateprofile", profilePayload, true, true))
                // formik.resetForm();
                setSaveBtnLoading(false);
                return response

            }
            catch (error) {
                console.error(error)
                setSaveBtnLoading(false);
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };


    useEffect(() => {
        if (loginData) {
            formik.setValues({
                firstName: loginData.data.firstName || "",
                lastName: loginData.data.lastName || "",
                gender: loginData.data.gender || "",
                dob: loginData.data.dob ? parseDate(loginData.data.dob) : null,
                mobile: loginData.data.mobile || "",
            });
        }
        setImage(`${baseURL}${loginData.data.profileImage}` || "");
    }, [loginData]);

    return (
        <>
            <div className="w-max-content ">
                <h4 className='font-semibold mb-6'>Profile Setting</h4>

                <div className='flex flex-column align-items-center justify-content-center lg:flex-row lg:align-items-stretch  p-3 border-200 border-3 border-round' style={{ gap: "3rem" }}>

                    <div className=" flex flex-column align-items-center profile-img surface-card p-4">
                        <h4 className='text-white w-full mb-6'>Profile Picture</h4>

                        <div className="edit-profile-img" >

                            <div className="preview-img">
                                {image ? (
                                    <Image
                                        preview
                                        src={image}
                                        alt="Profile"
                                    />
                                ) : (
                                    <Image src={DummyImage} preview />
                                )}
                            </div>

                            <label htmlFor="file-input">
                                <i size={16} className="pi pi-pencil m-1"></i>
                            </label>


                            <InputText
                                id="file-input"
                                type="file"
                                accept="image/*"
                                name="file"
                                value={formik.values.file || ""}
                                onChange={(e) => {
                                    handleImageChange(e);
                                    formik.handleChange(e)
                                }}
                                style={{ display: "none" }}
                            />
                        </div>
                        <h3 className="text-white mt-4">{loginData?.data?.firstName + " " + loginData?.data?.lastName}</h3>
                    </div>

                    <form className="profile-form" onSubmit={formik.handleSubmit}>
                        <div className="w-full surface-card py-4 px-4 ">
                            <h4 className='text-white mb-6'>Personal Detail</h4>
                            <div className="grid">
                                <div className="col-12 lg:col-6">
                                    <InputText id="firstName" type="text" name="firstName" placeholder="Enter First Name" value={formik.values.firstName || ""} onChange={formik.handleChange} className="w-full mb-2 p-3" />
                                    {getFormErrorMessage("firstName")}
                                </div>
                                <div className="col-12 lg:col-6">
                                    <InputText id='lastName' type="text" name="lastName" placeholder="Enter Last Name" value={formik.values.lastName || ""} onChange={formik.handleChange} className="w-full mb-2 p-3" />
                                    {getFormErrorMessage("lastName")}
                                </div>
                                <div className="col-12 lg:col-6">
                                    <Calendar id='dob' type="date" name="dob" placeholder="Enter Date Of Birth" value={formik.values.dob || null} onChange={formik.handleChange} className=" input-calender w-full mb-2 text-white  " />
                                    {getFormErrorMessage("dob")}
                                </div>
                                <div className="col-12 lg:col-6">
                                    <InputText id='corporateCode' type="text" name="corporateCode" placeholder="Corporate Code" value={formik.values.corporateCode || ""} onChange={formik.handleChange} className="w-full mb-2 p-3" />
                                </div>
                                <div className="col-12 lg:col-6">
                                    <InputText id='mobile' type="number" name="mobile" placeholder="Enter Phone No." value={formik.values.mobile || ""} onChange={formik.handleChange} className="w-full mb-2 p-3" />
                                    {getFormErrorMessage("mobile")}
                                </div>
                                <div className="col-12 lg:col-6">
                                    <Dropdown id="gender" name="gender" placeholder="--Select Gender--" options={genderLov} optionLabel="name" optionValue="value" value={formik.values.gender || ""} onChange={formik.handleChange} className="w-full " />
                                    {getFormErrorMessage("gender")}
                                </div>
                            </div>
                            <div className="">
                                <Button label="Update" loading={saveBtnLoading} type="submit" className="block font-medium mx-auto mt-2 text-lg w-9rem" />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default PassengerProfile